import { supabase } from "@/lib/supabase";
import { State } from "./types";
import { StorageBucketsEnum } from "../../types/enums";
import { useCentralStore } from ".";

export const initialState: State = {
	mfaVerified: false,
	mfaAuthenticated: false,
	mfaEnrolled: false,
	role: null,
	mfaDialogOpen: false,
	initialized: false,
	clientId: null,
	organization: null,
	subscription: null,
	subscriptionTier: null,
	userId: null,
	userEmail: null,
	isConnectUser: false,
	clientsLookup: {},
	connectedOrgIdToClientId: {},
	client: null,
	articles: {},
	profile: null,
	guarantorLookup: {},
	practitionersLookup: {},
	searchConfig: null,
	clientLoading: true,
	clientsLoading: true,
	bankAccountsLookup: {},
	debugMode: false,

	clientOrganizationId: null,
	connectedOrganizationEmail: null,
	connectedOrganizationType: null,

	// Regions state
	activatedRegions: [],
	regionsLoading: false,

	// Price list regions state
	activatedPriceListRegions: [],
	priceListRegionsLoading: false,

	allDataInitialized: false,
	appInitializedAt: null,

	// Upload status for migration page
	uploadStatus: "idle",

	// Password setup status for OTP users (if they got invited via dentconnect)
	needsPasswordSetup: null,

	clientFetchEpoch: 0,
	vendorFetchEpoch: 0,
};

export const fetchClientAvatar = async (avatar_path: string) => {
	const organizationId = useCentralStore.getState().organization?.id;
	const image_src = (
		await supabase.storage
			.from(StorageBucketsEnum.ORG_V1)
			.createSignedUrl(`${organizationId}/${avatar_path}`, 3600, {
				transform: {
					quality: 35,
				},
			})
	).data?.signedUrl as string;

	return image_src;
};

export const buildConnectedOrgIdToClientId = (
	clientsLookup: Record<
		string,
		{ id?: string | null; connected_organization_id?: string | null }
	>
): Record<string, string> => {
	const map: Record<string, string> = {};
	for (const client of Object.values(clientsLookup)) {
		if (client.connected_organization_id && client.id) {
			map[client.connected_organization_id] = client.id;
		}
	}
	return map;
};

// usage of TEMPLATE_CODE for jumbos is deprecated!
// This code is also used in the db rpcs
export const TEMPLATE_CODE = "template-8ed86c65-28a3-4627-a4b0-a68ad61f5876";
